export var Header;
(function (Header) {
    Header["AppDomain"] = "X-Appdomainid";
    Header["Locale"] = "Accept-Language";
    Header["SalesChannel"] = "X-Sales-Channel";
})(Header || (Header = {}));
export var ImageSize;
(function (ImageSize) {
    ImageSize[ImageSize["Large"] = 762] = "Large";
    ImageSize[ImageSize["Medium"] = 375] = "Medium";
    ImageSize[ImageSize["Small"] = 284] = "Small";
    ImageSize[ImageSize["ExtraSmall"] = 173] = "ExtraSmall";
    ImageSize[ImageSize["Thumbnail"] = 62] = "Thumbnail";
})(ImageSize || (ImageSize = {}));
export var PRODUCTION_LOCAL_CONTENTFUL_URL = 'https://pegasus-proxy-skipper.zlounge.zalan.do/proxy/contentful';
export var PRODUCTION_CONTENTFUL_URL = 'http://lounge-contentful-proxy.ingress.cluster.local';
export var TOTAL_CAMPAIGNS_TO_DISPLAY = 40;
export var MIN_CAMPAIGNS_TO_DISPLAY_BUTTON = 50;
/**
 * Please follow the naming convention for features:
 * - Use UpperCamelCase for the feature names (e.g., KeepArticlesInCart)
 * - Use kebab-case for the string values (e.g., 'keep-articles-in-cart')
 */
export var Features;
(function (Features) {
    Features["ArticleMedia"] = "article-media";
    Features["CampaignFeed"] = "campaign-feed";
    Features["LeavingSoon"] = "leaving-soon";
})(Features || (Features = {}));
